/**
 * Shop-page compatibility for catalogue brand logos (Planet, DOOD-3128).
 *
 * Must NOT target every slide: IZEE-style photo banners (4/12–12/12) need the
 * default max-width caps and bg-cover. Only 3/12 slides get contain + no max-width.
 * `carousel-layout-photos` on the carousel host opts out entirely.
 */
export const SHOP_PAGE_CAROUSEL_COMPAT_CLASSES = [
  '[&_app-carousel-block:not(.carousel-layout-photos)>div>div]:flex',
  '[&_app-carousel-block:not(.carousel-layout-photos)>div>div]:w-full',
  // safe center: logos stay centered when they fit; overflowing rows start-align so
  // the first slide is reachable (plain justify-center clips the left overflow).
  '[&_app-carousel-block:not(.carousel-layout-photos)>div>div]:justify-[safe_center]',
  '[&_app-carousel-block:not(.carousel-layout-photos)>div>div]:gap-3',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12]:!max-w-none',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12]:shrink-0',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:flex',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:min-h-28',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:items-center',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:justify-center',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:!bg-contain',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:bg-center',
  '[&_app-carousel-block:not(.carousel-layout-photos)_app-carousel-slide-card-block>div.w-3\\/12>a]:bg-no-repeat',
].join(' ');

/** Tokens that must never be applied unscoped on the shop page (photo banners). */
export const FORBIDDEN_UNSCOPED_SHOP_PAGE_CAROUSEL_TOKENS = [
  '[&_app-carousel-slide-card-block>div]:!max-w-none',
  '[&_app-carousel-slide-card-block_a]:!bg-contain',
  '[&_app-carousel-slide-card-block_a]:min-h-28',
] as const;
